import { ContactShadows, Environment } from '@react-three/drei'
import { Suspense } from 'react'

import { createCustomPhoenixLayoutElement } from '@salsita-ai/platform-project-sdk/domain'
import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'

import { Floor } from '../scene/Floor.js'

const ENVIRONMENT_HDR = '/environments/interior_haussmannian_front_day_light_07.hdr'

export const appEnvironmentElement = createCustomPhoenixLayoutElement('AppEnvironment', () => {
  const { getResourceUrl } = useResourceUrl()
  return (
    <>
      <directionalLight position={[0, 2000, 3000]} intensity={0.5} color="#fff1dd" />
      <directionalLight position={[0, 2000, -3000]} intensity={0.2} color="#d6f3ff" />
      <directionalLight position={[2000, 2000, 0]} intensity={0.5} color="#feeab3" />
      <directionalLight position={[-2000, 2000, 1000]} intensity={0.5} color="#d7f4ff" />
      <ambientLight intensity={0.5} />
      <Environment files={getResourceUrl(ENVIRONMENT_HDR)} />
      <Suspense fallback={null}>
        <Floor />
      </Suspense>
      <ContactShadows
        position={[0, 0, 0]}
        blur={0.2}
        opacity={0.5}
        near={0}
        far={10000}
        width={10000}
        height={10000}
        color="#3c372f"
        renderOrder={1}
      />
    </>
  )
})
